module.exports = __webpack_public_path__ + "static/img/granda.ce7b91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/granda.jpg
// module id = 473
// module chunks = 11